import React, { useState, useEffect } from 'react';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import './style.scss';
import { useSelector } from 'react-redux';
import methodModel from '../../methods/methods';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/global/layout';
import { Tooltip } from 'antd';
import { toast } from 'react-toastify';
import 'react-quill/dist/quill.snow.css';
import SelectDropdown from '../../components/common/SelectDropdown';

const AddEditassessment = () => {
  const { id } = useParams();
  const [form, setform] = useState({
    course_id: "",
    questions_id: [],
  });
  const [CourseID, setCourseID] = useState("")
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const user = useSelector((state) => state.user);
  const formValidation = [{ key: 'name', required: true }];
  const [Courses, setCourses] = useState([]);

  const GetCourses = () => {
    ApiClient.get('all/assessment/course', { status: 'active', isDeleted: false }).then(
      (res) => {
        if (res.success) {
          let array = [];
          res?.data?.map((itm) => {
            array.push({ id: itm?.id, name: itm?.title });
          });
          setCourses(array);
        }
      }
    );
  };

  useEffect(() => {
    GetCourses();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (form?.course_id?.length == 0 || selectedQuestions?.length == 0) {
      return false;
    }
    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid) return;
    let method = 'post';
    let url = 'assessment';
    let value = {
      name: form.name,
      course_id: form?.course_id,
      weightage: form?.weightage,
      minimum_score: form?.minimum_score,
      questions_id: selectedQuestions,
    };
    if (id) {
      method = 'put';
      url = 'assessment';
      value.id = JSON.parse(id);
    } else {
      value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        setTimeout(() => {
          toast.success(res?.message);
        }, 300);
        history(`/assessment`);
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    GetCourses();
    if (id) {
      loader(true);
      ApiClient.get('assessment', { id }).then((res) => {
        if (res.success) {
          setform({
            ...form,
            course_id: res?.data?.course_id?.id,
            questions_id: res?.data?.questions_id,
            name: res?.data?.name,
            weightage: res?.data?.weightage,
            minimum_score: res?.data?.minimum_score,
          });
          setCourseID(res?.data?.course_id?.title)
          setSelectedQuestions(res?.data?.questions_id)
          setSelectedTitles(res?.data?.questions_details?.map(itm => itm?.title))
        }
        loader(false);
      });
    }
  }, [id]);

  const [titledata, settitledata] = useState([])
  const GetQuestionWithTitle = () => {
    loader(true)
    ApiClient.get("all/assessment").then((res) => {
      if (res?.success) {
        settitledata(res?.data)
        loader(false)
      }
    })
  }

  useEffect(() => {
    GetQuestionWithTitle()
  }, [])

  // const [selectedQuestions, setSelectedQuestions] = useState([]);
  // const handleCheckboxChange = (check, questionId, title) => {
  //   if (check) {

  //     setSelectedQuestions(selectedQuestions.filter(id => id !== questionId));
  //     setselecttitle([...title])
  //   } else {
  //     setSelectedQuestions([...selectedQuestions, questionId]);
  //     setselecttitle(null)
  //   }
  // };
  // const [selecttitle, setselecttitle] = useState([]);
  // const HandleAll = (check, data, newdata) => {

  //   if (check) {
  //     setselecttitle(newdata?.title)
  //     setSelectedQuestions([...data])
  //   } else {
  //     setselecttitle(null)
  //     setSelectedQuestions([])
  //   }
  // };

  // Handle AllCheckbox
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  const handleTitleSelection = (title) => {
    let selectedQuestionIds = [];

    const selectedTitle = titledata.find(item => item.title === title);
    if (selectedTitle) {
      selectedQuestionIds = selectedTitle.questions.map(question => question.id);
    }

    setSelectedTitles(selectedTitles => (
      selectedTitles.includes(title) ? selectedTitles.filter(item => item !== title) : [...selectedTitles, title]
    ));
    setSelectedQuestions(selectedQuestions => (
      selectedTitles.includes(title) ? selectedQuestions.filter(id => !selectedQuestionIds.includes(id)) : [...selectedQuestions, ...selectedQuestionIds]
    ));
  };

  const handleQuestionSelection = (questionId) => {
    setSelectedQuestions(selectedQuestions => (
      selectedQuestions.includes(questionId) ? selectedQuestions.filter(item => item !== questionId) : [...selectedQuestions, questionId]
    ));

    const selectedTitleIds = titledata.filter(title => title.questions.some(question => selectedQuestions.includes(question.id))).map(title => title.title);
    setSelectedTitles(selectedTitleIds);
  };

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   discard mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? 'Edit' : 'Add'} Assessment
                </h3>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <>
                <div className="col-span-12 md:col-span-6">
                  <label>
                    Name<span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form?.name}
                    onChange={(e) => setform({ ...form, name: e.target.value })}
                    required
                  />
                </div>
                <div className="col-span-12 md:col-span-6">
                  <label>
                    Weightage<span className="star">*</span>
                  </label>
                  <input
                    type="number"
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form?.weightage}
                    onChange={(e) => {
                      const inputvalue = e.target.value;
                      if (inputvalue >= 0) {
                        setform({ ...form, weightage: inputvalue });
                      }
                    }}
                    onKeyPress={(e) => {
                      const allowedKeys = [
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '.',
                      ];
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    required
                  />
                </div>
                <div className="col-span-12 md:col-span-6">
                  <label>
                    Minimum Score<span className="star">*</span>
                  </label>
                  <input
                    type="number"
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form?.minimum_score}
                    onChange={(e) => {
                      const inputdata = e.target.value;
                      if (inputdata >= 0) {
                        setform({ ...form, minimum_score: inputdata });
                      }
                    }}
                    onKeyPress={(e) => {
                      const allowedKeys = [
                        '0',
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '.',
                      ];
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    required
                  />
                </div>

                <div className="col-span-6 md:col-span-6">
                  <label>
                    Course<span className="star">*</span>
                  </label>
                  {id ?
                    <input
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={CourseID || ""}
                      disabled
                    />
                    :
                    <div className="custom_dropdown">
                      <SelectDropdown
                        id="statusDropdown"
                        displayValue="name"
                        placeholder="Select Course"
                        intialValue={form?.course_id}
                        result={(e) => setform({ ...form, course_id: e.value })}
                        options={Courses}
                        theme="search"
                      />
                      {submitted && form.course_id?.length == 0 ? (
                        <div className="text-danger">Course is Required</div>
                      ) : (
                        <></>
                      )}
                    </div>}
                </div>

                {titledata?.map((itm) => <div className="col-span-12 md:col-span-6 mb-3 shadow-lg p-4 rounded-lg border">
                  <div className='flex items-center mb-3 pb-3 border-b-[1px]'>
                    <input
                      value={itm.title}
                      onChange={() => handleTitleSelection(itm.title)}
                      checked={selectedTitles.includes(itm.title)}
                      type="checkbox" className='w-[15px] h-[15px]'
                    />
                    <p className='font-[600] text-[#a12238] '>{methodModel.capitalizeFirstLetter(itm?.title)}</p>
                  </div>
                  {itm?.questions.map((item) => <div className='flex items-center mb-1'>
                    <input
                      value={item.id}
                      onChange={() => handleQuestionSelection(item.id)}
                      checked={selectedQuestions.includes(item.id)}
                      type="checkbox" className='w-[15px] h-[15px]'
                    />

                    <p className='text-14px'>{methodModel.capitalizeFirstLetter(item?.question)}</p>
                  </div>)}

                </div>)}

              </>
            </div>
            {submitted && selectedQuestions.length == 0 ? (
              <div className="text-danger">Question is Required</div>
            ) : (
              <></>
            )}
            <div className="flex justify-end mt-3">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditassessment;
